module.exports = __webpack_public_path__ + "static/effecten-klimaatverandering-nederland-climate-adaptation-services-27e3e71fd35a13f7447ed4f59fedebcf.jpg";